import {
  SET_EXPAND_INPUT,
  SET_SEARCH_TERM,
  SET_MOBILE_SEARCH,
  SET_DESK_SEARCH
} from '@/store/constants'

export const namespaced = true

export const state = {
  expandInput: false,
  searchTerm: '',
  mobileSearch: null,
  deskSearch: null
}

export const actions = {
  setExpandInput({ commit }, expandInput) {
    commit(SET_EXPAND_INPUT, expandInput)
  },
  setSearchTerm({ commit }, searchTerm) {
    commit(SET_SEARCH_TERM, searchTerm)
  },
  setMobileSearch({ commit }, mobileSearch) {
    commit(SET_MOBILE_SEARCH, mobileSearch)
  },
  setDeskSearch({ commit }, deskSearch) {
    commit(SET_DESK_SEARCH, deskSearch)
  }
}

export const mutations = {
  [SET_EXPAND_INPUT]: (state, expandInput) => {
    state.expandInput = expandInput
  },
  [SET_SEARCH_TERM]: (state, searchTerm) => {
    state.searchTerm = searchTerm
  },
  [SET_MOBILE_SEARCH]: (state, mobileSearch) => {
    state.mobileSearch = mobileSearch
  },
  [SET_DESK_SEARCH]: (state, deskSearch) => {
    state.deskSearch = deskSearch
  }
}

export const getters = {
  expandInput: state => state.expandInput,
  searchTerm: state => state.searchTerm,
  mobileSearch: state => state.mobileSearch,
  deskSearch: state => state.deskSearch
}
